"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var map = require('lodash/map');

var isEmpty = require('lodash/isEmpty');

var traverseDecisionTree = require('../util/traverseDecisionTree');

var _require = require('./helpers'),
    isLetterpressComponent = _require.isLetterpressComponent,
    excludeFromLetterpress = _require.excludeFromLetterpress,
    excludeFromDoubleThick = _require.excludeFromDoubleThick;

function isAnException(exceptions, params) {
  if (!exceptions || isEmpty(exceptions)) {
    return false;
  }

  return traverseDecisionTree(params, exceptions);
}

function getIndependentVariables(settings, params) {
  if (!settings["default"]) {
    console.error(settings, params);
    throw new Error('there were no defaults');
  }

  var _settings$default = settings["default"],
      bleed = _settings$default.bleed,
      orientation = _settings$default.orientation,
      length = _settings$default.length;
  var bleed_exception = bleed === 'b' ? 'n' : 'b';
  var orientation_exception = orientation === 'L' ? 'P' : 'L';
  var length_exception = length === 'l' ? 's' : 'l';
  var independentVariables = {
    bleed: settings.exceptions && isAnException(settings.exceptions.bleed, params) ? bleed_exception : bleed,
    orientation: settings.exceptions && isAnException(settings.exceptions.orientation, params) ? orientation_exception : orientation
  };

  if (length) {
    independentVariables.length = settings.exceptions && isAnException(settings.exceptions.length, params) ? length_exception : length;
  }

  return independentVariables;
}

function getDependentVariables(settings, params) {
  var values = {};
  map(['cutCode', 'queue', 'size', 'up', 'weight', 'num_to_add'], function (key) {
    var val = 'n/a';

    if (settings[key]) {
      val = traverseDecisionTree(params, settings[key]);
    }

    values[key] = val || 'n/a';
  });
  return values;
}

function getDefaultPaper(paperType, settings) {
  if (settings[paperType]) {
    return settings[paperType];
  }

  return paperType;
}

function componentPaperType(product, component) {
  // if the component already has a specified paper_type,
  // this should be the value used by the algorithm.
  if (component.paper_type) {
    return component.paper_type;
  }

  if ('envelope_color' in component && component.envelope_color !== 'Paper') {
    return component.envelope_color;
  } // if it's a White/Ivory Cotton suite,
  // the envelopes, for example, go to the corresponding White/Ivory Matte paper type
  // (also catches double thick cotton, if applicable)


  if (excludeFromLetterpress(component) && product.paper_type.match(/(white|ivory) (cotton)/i)) {
    var matchers = product.paper_type.match(/(white|ivory) (cotton)/i);
    return "".concat(matchers[1], " Matte");
  } // Likewise, if the suite is on double thick paper,
  // the envelopes, for example, go to the corresponding single-ply paper.


  if (excludeFromDoubleThick(component) && product.paper_type.match(/double thick/i)) {
    return product.paper_type.replace(/double thick /i, '');
  } // if this is a letterpress component, and the suite is a regular paper suite
  // (e.g. a LP component added to a Classic Invitation Suite)
  // let's make sure it gets a cotton paper.


  if (isLetterpressComponent(component)) {
    if (product.paper_type.match(/(matte|shimmer)/i)) {
      return product.paper_type.replace(/(matte|shimmer)/i, 'Cotton');
    }
  } // otherwise, the paper type should be passed down from the parent.


  return product.paper_type;
}
/**
 * gets the bleed, orientation, length, cutCode, size, weight, queue, etc.
 * @private
 * @param {Product} product
 * @param {Component} component
 * @param {*} settings
 */


function componentDefaults(product, component, _ref, _ref2) {
  var override = _ref.override;
  var impositionsTable = _ref2.impositionsTable,
      paperTypes = _ref2.paperTypes;
  var impositions = {}; // let's pass this back along with impositions

  impositions.paper_type = componentPaperType(product, component); // design_name should come from product, unless for some reason it's already
  // been applied to the product as an override.

  impositions.design_name = component.design_name || product.design_name; // combine the parameters and pass down the object, without
  // altering the object itself.
  // Let's avoid using ShineProducts.instance().make() if we can help it.

  var params = _objectSpread(_objectSpread({}, component), impositions);

  var componentImpositionSettings = impositionsTable[component.name];
  var default_overrides = {
    bleed: component.bleed,
    length: component.length,
    orientation: component.orientation
  };

  if (Object.values(default_overrides).some(function (str) {
    return str === '';
  })) {
    throw new Error('If overrides aren\'t a value, they should be null, not \'\'');
  }

  var values;
  var defaults;

  if (componentImpositionSettings) {
    defaults = getIndependentVariables(componentImpositionSettings.defaults, params);

    if (!override) {
      if (default_overrides.bleed) {
        defaults.bleed = default_overrides.bleed;
      }

      if (default_overrides.orientation) {
        defaults.orientation = default_overrides.orientation;
      }

      if (default_overrides.length) {
        defaults.length = default_overrides.length;
      }
    }

    values = getDependentVariables(componentImpositionSettings.values, _objectSpread(_objectSpread({}, params), defaults));
  } // we're keeping paper out of the impositions table, since it's a one-to-one operation.


  var paper = getDefaultPaper(impositions.paper_type, paperTypes);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, impositions), defaults), values), {}, {
    paper: paper
  });
}

module.exports = componentDefaults;